export default "__VITE_ASSET__cruzyimE__"